/* eslint-disable max-lines */
export const DEFAULT_FLOW_PROJECT_NAME = 'fasting';
export const DEFAULT_EXPIRE_CONFIG_TIME = 1440;

export const DEFAULT_FLOW = {
    branch_name: 'default',
    flow_name: 'fasting__default__default__client',
    start_page: {
        id: 'index',
        name: 'index',
        config: {},
    },
    onboarding_flow: [
        {
            id: 'ob_social_proof_a',
            name: 'ob_social_proof_a',
            config: {},
        },
        {
            id: 'ob_goals_old',
            name: 'ob_goals_old',
            config: {},
        },
        {
            id: 'ob_body_type_current',
            name: 'ob_body_type_current',
            config: {},
        },
        {
            id: 'ob_body_type_target',
            name: 'ob_body_type_target',
            config: {},
        },
        {
            id: 'ob_target_zones',
            name: 'ob_target_zones',
            config: {},
        },
        {
            id: 'ob_happy_weight',
            name: 'ob_happy_weight',
            config: {},
        },
        {
            id: 'ob_time_breakfast',
            name: 'ob_time_breakfast',
            config: {},
        },
        {
            id: 'ob_time_lunch',
            name: 'ob_time_lunch',
            config: {},
        },
        {
            id: 'ob_time_dinner',
            name: 'ob_time_dinner',
            config: {},
        },
        {
            id: 'ob_pref_eat_place',
            name: 'ob_pref_eat_place',
            config: {},
        },
        {
            id: 'ob_weekend',
            name: 'ob_weekend',
            config: {},
        },
        {
            id: 'ob_job_load',
            name: 'ob_job_load',
            config: {},
        },
        {
            id: 'ob_job_active',
            name: 'ob_job_active',
            config: {},
        },
        {
            id: 'ob_stairs',
            name: 'ob_stairs',
            config: {},
        },
        {
            id: 'ob_walking',
            name: 'ob_walking',
            config: {},
        },
        {
            id: 'ob_water',
            name: 'ob_water',
            config: {},
        },
        {
            id: 'ob_sleep',
            name: 'ob_sleep',
            config: {},
        },
        {
            id: 'ob_back_issue',
            name: 'ob_back_issue',
            config: {},
        },
        {
            id: 'ob_bad_habits',
            name: 'ob_bad_habits',
            config: {},
        },
        {
            id: 'ob_fasting_awareness',
            name: 'ob_fasting_awareness',
            config: {},
        },
        {
            id: 'ob_motivation',
            name: 'ob_motivation',
            config: {},
        },
        {
            id: 'ob_height_a',
            name: 'ob_height_a',
            config: {},
        },
        {
            id: 'ob_weight_current_a',
            name: 'ob_weight_current_a',
            config: {},
        },
        {
            id: 'ob_weight_target_a',
            name: 'ob_weight_target_a',
            config: {},
        },
        {
            id: 'ob_age_a',
            name: 'ob_age_a',
            config: {},
        },
        {
            id: 'feedback_summary',
            name: 'feedback_summary',
            config: {},
        },
        {
            id: 'ob_occasion',
            name: 'ob_occasion',
            config: {},
        },
        {
            id: 'ob_occasion_result',
            name: 'ob_occasion_result',
            config: {},
        },
        {
            id: 'creating_d',
            name: 'creating_d',
            config: {},
        },
        {
            id: 'email',
            name: 'email',
            config: {},
        },
        {
            id: 'email_consent',
            name: 'email_consent',
            config: {},
        },
        {
            id: 'result',
            name: 'result',
            config: {},
        },
    ],
    payment_flow: [
        {
            id: 'vip_support',
            name: 'vip_support',
            parent_id: 'upsell',
            is_paid: true,
            skip_checkout: true,
            products: [
                {
                    payment_type: 'subscription',
                    id: '4071853f-eaf9-4988-bbb8-6bd9ab872e53',
                    price: 99,
                    name: 'One-month (0.99)',
                    trial: 0,
                    period: 31,
                    product_code: [],
                    price_per_state: 99,
                    start_price_per_state: 99,
                    is_preselected: false,
                    start_price: 99,
                    product_state: 'per_month',
                    ltv: 136,
                    processor: 'solid',
                },
            ],
            config: {},
        },
        {
            id: 'vip_support',
            name: 'vip_support',
            parent_id: 'upsell',
            is_paid: false,
            skip_checkout: true,
            products: [
                {
                    payment_type: 'subscription',
                    id: '4071853f-eaf9-4988-bbb8-6bd9ab872e53',
                    price: 99,
                    name: 'One-month (0.99)',
                    trial: 0,
                    period: 31,
                    product_code: [],
                    price_per_state: 99,
                    start_price_per_state: 99,
                    is_preselected: false,
                    start_price: 99,
                    product_state: 'per_month',
                    ltv: 136,
                    processor: 'solid',
                },
            ],
            config: {},
        },
        {
            id: 'vip_support',
            name: 'vip_support',
            parent_id: 'upsell',
            is_paid: true,
            skip_checkout: true,
            products: [
                {
                    payment_type: 'subscription',
                    id: '4071853f-eaf9-4988-bbb8-6bd9ab872e53',
                    price: 99,
                    name: 'One-month (0.99)',
                    trial: 0,
                    period: 31,
                    product_code: [],
                    price_per_state: 99,
                    start_price_per_state: 99,
                    is_preselected: false,
                    start_price: 99,
                    product_state: 'per_month',
                    ltv: 136,
                    processor: 'solid',
                },
            ],
            config: {},
        },
        {
            id: 'offer_a1_foxtrot1',
            name: 'offer_a1_foxtrot1',
            parent_id: 'payment_g1_foxtrot1',
            is_paid: false,
            skip_checkout: false,
            products: [
                {
                    payment_type: 'subscription',
                    id: 'ac79d9dd-2736-4db5-88ba-512c2dc1ea01',
                    price: 550,
                    name: 'One-week intro (5.50) + One-week (10.49)',
                    trial: 7,
                    period: 7,
                    product_code: [],
                    price_per_state: 79,
                    start_price_per_state: 150,
                    is_preselected: false,
                    start_price: 1049,
                    product_state: 'per_day',
                    ltv: 2141,
                    processor: 'solid',
                },
                {
                    payment_type: 'subscription',
                    id: '3af9e081-b45d-401e-b858-c6a68e153467',
                    price: 1199,
                    name: 'One-month intro (11.99) + One-month (30.99)',
                    trial: 31,
                    period: 31,
                    product_code: [],
                    price_per_state: 39,
                    start_price_per_state: 100,
                    is_preselected: true,
                    start_price: 3099,
                    product_state: 'per_day',
                    ltv: 3778,
                    processor: 'solid',
                },
                {
                    payment_type: 'subscription',
                    id: 'eb667562-a647-4ee7-bd72-b591148dd0d9',
                    price: 2149,
                    name: 'Three-month intro (21.49) + Three-month (53.19)',
                    trial: 90,
                    period: 90,
                    product_code: [],
                    price_per_state: 24,
                    start_price_per_state: 59,
                    is_preselected: false,
                    start_price: 5319,
                    product_state: 'per_day',
                    ltv: 3090,
                    processor: 'solid',
                },
                {
                    payment_type: 'subscription',
                    id: '9ee130e4-8933-46da-87fa-2c3948a96fc5',
                    price: 1049,
                    name: 'One-week intro (10.49) + One-week (10.49)',
                    trial: 7,
                    period: 7,
                    product_code: [],
                    price_per_state: 150,
                    start_price_per_state: 0,
                    is_preselected: false,
                    start_price: 1049,
                    product_state: 'per_day',
                    ltv: 2501,
                    processor: 'solid',
                },
                {
                    payment_type: 'subscription',
                    id: 'ee4ac51e-17c6-4e61-a565-8c5a39f15bdd',
                    price: 3099,
                    name: 'One-month intro (30.99) + One-month (30.99)',
                    trial: 31,
                    period: 31,
                    product_code: [],
                    price_per_state: 100,
                    start_price_per_state: 0,
                    is_preselected: false,
                    start_price: 3099,
                    product_state: 'per_day',
                    ltv: 4703,
                    processor: 'solid',
                },
                {
                    payment_type: 'subscription',
                    id: 'f76ef55c-8026-422a-bbc9-c2b5d0442670',
                    price: 5319,
                    name: 'Three-month intro (53.19) + Three-month (53.19)',
                    trial: 90,
                    period: 90,
                    product_code: [],
                    price_per_state: 59,
                    start_price_per_state: 0,
                    is_preselected: false,
                    start_price: 5319,
                    product_state: 'per_day',
                    ltv: 5381,
                    processor: 'solid',
                },
            ],
            config: {},
        },
        {
            id: 'upsell',
            name: 'upsell',
            parent_id: 'payment_g1_foxtrot1',
            is_paid: true,
            skip_checkout: false,
            products: [
                {
                    payment_type: 'lifetime',
                    id: 'fat_burning_gd__weight_loss_gd',
                    price: 298,
                    name: 'fat_burning_gd__weight_loss_gd',
                    trial: 0,
                    period: 1,
                    product_code: [],
                    price_per_state: 699,
                    start_price_per_state: 1,
                    is_preselected: true,
                    start_price: 1500,
                    product_state: 'per_day',
                    ltv: 215,
                    processor: 'solid',
                },
                {
                    payment_type: 'lifetime',
                    id: 'weight_loss_gd',
                    price: 199,
                    name: 'weight_loss_gd',
                    trial: 0,
                    period: 1,
                    product_code: [],
                    price_per_state: 499,
                    start_price_per_state: 1,
                    is_preselected: false,
                    start_price: 1000,
                    product_state: 'per_day',
                    ltv: 144,
                    processor: 'solid',
                },
                {
                    payment_type: 'lifetime',
                    id: 'fat_burning_gd',
                    price: 199,
                    name: 'fat_burning_gd',
                    trial: 0,
                    period: 1,
                    product_code: [],
                    price_per_state: 499,
                    start_price_per_state: 1,
                    is_preselected: false,
                    start_price: 1000,
                    product_state: 'per_day',
                    ltv: 144,
                    processor: 'solid',
                },
            ],
            config: {},
        },
        {
            id: 'upsell',
            name: 'upsell',
            parent_id: 'offer_a1_foxtrot1',
            is_paid: true,
            skip_checkout: false,
            products: [
                {
                    payment_type: 'lifetime',
                    id: 'fat_burning_gd__weight_loss_gd',
                    price: 298,
                    name: 'fat_burning_gd__weight_loss_gd',
                    trial: 0,
                    period: 1,
                    product_code: [],
                    price_per_state: 699,
                    start_price_per_state: 1,
                    is_preselected: true,
                    start_price: 1500,
                    product_state: 'per_day',
                    ltv: 215,
                    processor: 'solid',
                },
                {
                    payment_type: 'lifetime',
                    id: 'weight_loss_gd',
                    price: 199,
                    name: 'weight_loss_gd',
                    trial: 0,
                    period: 1,
                    product_code: [],
                    price_per_state: 499,
                    start_price_per_state: 1,
                    is_preselected: false,
                    start_price: 1000,
                    product_state: 'per_day',
                    ltv: 144,
                    processor: 'solid',
                },
                {
                    payment_type: 'lifetime',
                    id: 'fat_burning_gd',
                    price: 199,
                    name: 'fat_burning_gd',
                    trial: 0,
                    period: 1,
                    product_code: [],
                    price_per_state: 499,
                    start_price_per_state: 1,
                    is_preselected: false,
                    start_price: 1000,
                    product_state: 'per_day',
                    ltv: 144,
                    processor: 'solid',
                },
            ],
            config: {},
        },
        {
            id: 'vip_support',
            name: 'vip_support',
            parent_id: 'upsell',
            is_paid: false,
            skip_checkout: true,
            products: [
                {
                    payment_type: 'subscription',
                    id: '4071853f-eaf9-4988-bbb8-6bd9ab872e53',
                    price: 99,
                    name: 'One-month (0.99)',
                    trial: 0,
                    period: 31,
                    product_code: [],
                    price_per_state: 99,
                    start_price_per_state: 99,
                    is_preselected: false,
                    start_price: 99,
                    product_state: 'per_month',
                    ltv: 136,
                    processor: 'solid',
                },
            ],
            config: {},
        },
        {
            id: 'payment_g1_foxtrot1',
            name: 'payment_g1_foxtrot1',
            parent_id: null,
            is_paid: null,
            skip_checkout: false,
            products: [
                {
                    payment_type: 'subscription',
                    id: '0eeb3104-bcce-4029-8dc0-6a48ded805ad',
                    price: 693,
                    name: 'One-week intro (6.93) + One-week (10.49)',
                    trial: 7,
                    period: 7,
                    product_code: [],
                    price_per_state: 99,
                    start_price_per_state: 150,
                    is_preselected: false,
                    start_price: 1049,
                    product_state: 'per_day',
                    ltv: 2244,
                    processor: 'solid',
                },
                {
                    payment_type: 'subscription',
                    id: '9ea6bce5-34fe-4ee3-93d9-4ea5f455bc37',
                    price: 1519,
                    name: 'One-month intro (15.19) + One-month (30.99)',
                    trial: 31,
                    period: 31,
                    product_code: [],
                    price_per_state: 49,
                    start_price_per_state: 100,
                    is_preselected: true,
                    start_price: 3099,
                    product_state: 'per_day',
                    ltv: 4009,
                    processor: 'solid',
                },
                {
                    payment_type: 'subscription',
                    id: '7ad6132e-71fc-47c9-9e82-dcea25af4ac3',
                    price: 2599,
                    name: 'Three-month intro (25.99) + Three-month (53.19)',
                    trial: 90,
                    period: 90,
                    product_code: [],
                    price_per_state: 29,
                    start_price_per_state: 59,
                    is_preselected: false,
                    start_price: 5319,
                    product_state: 'per_day',
                    ltv: 3877,
                    processor: 'solid',
                },
                {
                    payment_type: 'subscription',
                    id: '9ee130e4-8933-46da-87fa-2c3948a96fc5',
                    price: 1049,
                    name: 'One-week intro (10.49) + One-week (10.49)',
                    trial: 7,
                    period: 7,
                    product_code: [],
                    price_per_state: 150,
                    start_price_per_state: 0,
                    is_preselected: false,
                    start_price: 1049,
                    product_state: 'per_day',
                    ltv: 2501,
                    processor: 'solid',
                },
                {
                    payment_type: 'subscription',
                    id: 'ee4ac51e-17c6-4e61-a565-8c5a39f15bdd',
                    price: 3099,
                    name: 'One-month intro (30.99) + One-month (30.99)',
                    trial: 31,
                    period: 31,
                    product_code: [],
                    price_per_state: 100,
                    start_price_per_state: 0,
                    is_preselected: false,
                    start_price: 3099,
                    product_state: 'per_day',
                    ltv: 4703,
                    processor: 'solid',
                },
                {
                    payment_type: 'subscription',
                    id: 'f76ef55c-8026-422a-bbc9-c2b5d0442670',
                    price: 5319,
                    name: 'Three-month intro (53.19) + Three-month (53.19)',
                    trial: 90,
                    period: 90,
                    product_code: [],
                    price_per_state: 59,
                    start_price_per_state: 0,
                    is_preselected: false,
                    start_price: 5319,
                    product_state: 'per_day',
                    ltv: 5381,
                    processor: 'solid',
                },
            ],
            config: {},
        },
    ],
    expire: 1668066625424,
};
